import Cookies from 'universal-cookie';

const getUrlConnection = (monitoringStatus) => {
  const baseUrl = process.env.REACT_APP_SSE ?? process.env.REACT_APP_API_URL;
  const cookies = new Cookies();
  const operatorPresenceId = monitoringStatus?.presence?.id;

  const userIdentity = cookies.get('userIdentity');
  const isOperator = userIdentity?.isOperator;
  const isHost = userIdentity?.isHost;

  if (isOperator) return `${baseUrl}api/v1/monitoring-operator/sse/connect?operatorPresenceId=${operatorPresenceId}`;
  if (isHost) return `${baseUrl}api/v1/productivity-host/sse/connect`;
};

export default getUrlConnection;
